'use strict';
const angular = require('angular');

export class feedbackFormularComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    //this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.feedback});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.feedbackFormular', [])
  .component('feedbackFormular', {
    template: require('./feedback-formular.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: feedbackFormularComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/feedback-formular/feedback-formular.component.js